import { getVisualStateDataAttributes } from "../getVisualStateDataAttributes";

var tryGetBoolean = function tryGetBoolean(value) {
  return typeof value === 'boolean' ? value : undefined;
};

export function getCommonVisualStateDataAttributes(componentProps) {
  return getVisualStateDataAttributes({
    error: tryGetBoolean(componentProps['error']),
    warning: tryGetBoolean(componentProps['warning'])
  });
}